import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  children: React.ReactNode;
}

const buttonVariants = {
  default: 'bg-custom-blue-600 text-white hover:bg-custom-blue-700',
  destructive: 'bg-custom-blue-700 text-white hover:bg-custom-blue-800',
  outline: 'border border-custom-blue-300 bg-white hover:bg-custom-blue-50 text-custom-blue-900',
  secondary: 'bg-custom-blue-100 text-custom-blue-900 hover:bg-custom-blue-200',
  ghost: 'hover:bg-custom-blue-100 text-custom-blue-900',
  link: 'text-custom-blue-600 underline-offset-4 hover:underline',
};

const buttonSizes = {
  default: 'h-10 px-4 py-2',
  sm: 'h-9 rounded-md px-3',
  lg: 'h-11 rounded-md px-8',
  icon: 'h-10 w-10',
};

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'default', 
  size = 'default', 
  className = '', 
  children, 
  ...props 
}) => (
  <button
    className={`inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-custom-blue-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${buttonVariants[variant]} ${buttonSizes[size]} ${className}`}
    {...props}
  >
    {children}
  </button>
);
